import { useLazyLoadQuery } from "react-relay"
import { graphql } from "relay-runtime"
import { usePatientFileLockQuery as usePatientFileLock } from "@/modules/patients/services/__generated__/usePatientFileLockQuery.graphql"

const patientFileLockQuery = graphql`
  query usePatientFileLockQuery($patientId: ID!) {
    appointmentPatientById(id: $patientId) {
      patientFileLock {
        ...requestTakeOverDialog_patientFileLockFragment
      }
    }
  }
`

export function usePatientFileLockQuery(patientId: string) {
  const data = useLazyLoadQuery<usePatientFileLock>(patientFileLockQuery, { patientId })
  return data.appointmentPatientById?.patientFileLock
}
